<i18n
  src="@/locales/components/views/agro_exporter/production/uniq_final_packing_list/move_package_group.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="routeName('show_container_pallets')"
      :params="{
        agro_exporter_process_id: this.agro_exporter_process_id,
        container_id: this.container_id,
      }"
    >
    </go-back-link>

    <container-header
      :agro_exporter_process_id="agro_exporter_process_id"
      :container_code="container?.container_code"
    />

    <div v-if="load_general_data" class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>
        <div class="">
          <div class="sm:flex sm:items-start">
            <div class="sm:text-left sm:w-full">
              <div class="">
                <div class="flex flex-wrap">
                  <div
                    v-for="col in cols"
                    :key="col"
                    :class="['divide-y divide-gray-200', card_width_class]"
                  >
                    <div
                      v-for="row in rows"
                      :key="row"
                      :class="[
                        col == cols ? '' : 'border-r',
                        'border-gray-200',
                      ]"
                    >
                      <article
                        @click.prevent="selectPosition(row, col)"
                        :class="[
                          'overflow-hidden',
                          bg_color(row, col),
                          selected_class(row, col),
                        ]"
                      >
                        <!-- cardRoundedClass(col, row), -->
                        <header
                          class="flex place-content-center items-center leading-tight p-2 md:p-4"
                        >
                          <div
                            class="text-lg text-center flex place-content-center"
                          >
                            <div v-if="getPackageGroup(row, col)">
                              <i
                                class="fa-solid fa-pallet-boxes text-sm text-gray-500"
                              ></i>
                              {{ getPackageGroup(row, col).pg_code }}
                            </div>
                            <div v-else>
                              <i class="fa-solid fa-pallet text-gray-500"></i>
                            </div>
                          </div>
                        </header>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions">
            <white-button
              @click.prevent="gotToContainer()"
              :label="$t('labels.cancel_button')"
            />
            <span class="space-actions"></span>
            <success-button
              v-if="!proc_save_button"
              @click.prevent="submit()"
              :label="$t('labels.save_link')"
            />
            <success-button-processing v-else :label="$t('labels.save_link')" />
          </div>
        </div>
      </div>
    </div>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/uniq_final_packing_list/move_package_group.js";
import ContainerHeader from "@/components/views/agro_exporter/production/uniq_final_packing_list/ContainerHeader.vue";

export default {
  name: "MovePackageGroup",
  components: {
    ContainerHeader,
  },
  emit: ["update:packages-groups"],
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    container_id: { required: true },
    package_group_id: {
      required: true,
    },
  },
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      container: {},
      selected_position: {},
    };
  },
  computed: {
    card_width_class: function () {
      let cols = String(this.cols ?? 1);
      let width_class = `w-1/${cols}`;
      return `${width_class} lg:${width_class}`;
    },
    cols: function () {
      return this.container?.cols_package_groups;
    },
    package_groups() {
      return this.container?.package_groups || [];
    },
    rows: function () {
      return this.container?.rows_package_groups;
    },
  },
  methods: {
    bg_color(row, col) {
      if (this.is_current_position(row, col)) return `bg-gray-300`;
      return "";
    },
    cardRoundedClass: function (col, row) {
      let def_class =
        "relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500";
      if (col == 1 && row == 1) def_class += " rounded-tl-lg";
      if (col == this.cols && row == 1) def_class += " sm:rounded-tr-lg";
      if (col == 1 && row == this.rows) def_class += " sm:rounded-bl-lg";
      if (col == this.cols && row == this.rows) def_class += " rounded-br-lg";
      return def_class;
    },
    is_current_position: function (row, col) {
      let pg = this.getPackageGroup(row, col);
      return pg && pg.id == this.package_group_id;
    },
    is_selected_position: function (row, col) {
      return (
        this.selected_position.row == row && this.selected_position.col == col
      );
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer({
        container_id: this.container_id,
      });
      this.container = response.data;
      let current_package_group = this.container.package_groups.find(
        (pg) => pg.id == this.package_group_id
      );
      this.selected_position = {
        row: current_package_group.row_position,
        col: current_package_group.col_position,
      };
      this.load_general_data = true;
    },
    getPackageGroup: function (row, col) {
      return this.package_groups.find(
        (package_group) =>
          package_group.row_position === row &&
          package_group.col_position === col
      );
    },
    gotToContainer: function () {
      this.$router.push({
        name: this.routeName("show_container_pallets"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
        },
      });
    },
    selected_class: function (row, col) {
      if (this.is_current_position(row, col)) return "";
      if (this.is_selected_position(row, col)) return "bg-lime-400 opacity-75";
      return "";
    },
    selectPosition: function (row, col) {
      this.selected_position = { row, col };
    },
    submit: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.move({
          container_id: this.container_id,
          package_group_id: this.package_group_id,
          row_position: this.selected_position.row,
          col_position: this.selected_position.col,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.gotToContainer();
      } catch (error) {
        console.log(error);
      }
      this.proc_save_button = false;
    },
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => this.fetchContainer())
    );
  },
};
</script>
